module.exports = __webpack_public_path__ + "img/ic_country_function_img.4903ef88.png";